import { useEffect, useState } from "react";
import {
  AddAddressService,
  AddToCartService,
  DeleteAddressService,
  GetAllAddressService,
  RequestPaymentCartService,
} from "../../../services/MainScreen";
import Swal from "sweetalert2";
import {
  removeFromCart,
  setAddressIdCookie,
  setAmountCookie,
} from "../../../utility/Cookies";
import AddAddressComponent from "./AddAddressComponent";

export default function PageAddressComponent({
  setLoadingProcess,
  handlePrevProcess,
  handleNextProcess,
  selectdAddressId,
  setSetselectdAddressId,
  getCartList,
  setgetCartList,
}) {
  let [addresses, setAddresses] = useState([]);

  useEffect(() => {
    async function fetchDataAddress() {
      setLoadingProcess(true);
      let res = await GetAllAddressService();
      setAddresses(res.result);
      if (res.result.length > 0) setSetselectdAddressId(res.result[0].id);
      setLoadingProcess(false);
    }
    if (addresses.length < 1) fetchDataAddress();
  }, []);

  return (
    <>
      <div className="row form-group cart-checkout-shipping">
        <div className="col-md-3" />
        <div className="col-md-9 col-lg-6">
          <h4 className="cart-checkout-shipping-title"> ثبت آدرس جدید </h4>
          <div className="form-text cart-checkout-shipping-description">
            سفارش شما به آدرسی که در زیر ثبت می کنید ارسال خواهد شد.
          </div>
        </div>
      </div>
      <AddAddressComponent
        setAddresses={setAddresses}
        setSetselectdAddressId={setSetselectdAddressId}
      />
      <hr className="page-separator cart-checkout-separator" />
      <div className="row form-group cart-checkout-shipping">
        <div className="col-md-3" />
        <div className="col-md-9 col-lg-6">
          <h4 className="cart-checkout-shipping-title"> انتخاب آدرس </h4>
          <div className="form-text cart-checkout-shipping-description">
            سفارش شما به آدرسی که در زیر انتخاب می کنید ارسال خواهد شد.
          </div>
        </div>
        <table className="table table-bordered table-striped cart-details col-md-9 col-lg-6 mx-auto">
          <tbody>
            <tr className="cart-details-total">
              <th className="cart-details-total-label"> </th>
              <th className="cart-details-total-label"> کد پستی </th>
              <th className="cart-details-total-label"> آدرس </th>
              <th className="cart-details-total-label"> </th>
            </tr>
            {addresses.map((item, index) => {
              return (
                <tr key={index}>
                  <td className="cart-details-total-value text-green ">
                    <div className="custom-control custom-checkbox text-center text-md-right">
                      <input
                        className="custom-control-input signin-rememberme-input"
                        type="radio"
                        name="selectedAddress"
                        checked={item.id === selectdAddressId}
                        onClick={() => setSetselectdAddressId(item.id)}
                      />
                      <label
                        className="custom-control-label signin-rememberme-label"
                        for="lable-selectedAddress"
                      />
                    </div>
                  </td>
                  <td> {item.postal_code} </td>
                  <td> {item.address} </td>
                  <td>
                    <BTNDeletePageAddressComponent
                      id={item.id}
                      setAddresses={setAddresses}
                      selectdAddressId={selectdAddressId}
                      setSetselectdAddressId={setSetselectdAddressId}
                      selectdAdId={selectdAddressId}
                    />
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>

      <hr className="page-separator cart-checkout-separator" />
      <div className="row justify-content-end px-3">
        <button
          onClick={handlePrevProcess}
          type="button"
          className="btn btn-lg btn-link btn-block rounded mt-25 col-2"
        >
          بازگشت
        </button>
        <SendToPagePayment
          selectedAddressId={selectdAddressId}
          getCartList={getCartList}
          setgetCartList={setgetCartList}
        />
      </div>
    </>
  );
}

export const BTNDeletePageAddressComponent = ({
  setAddresses,
  id,
  setSetselectdAddressId,
  selectdAdId,
}) => {
  const [loadingDelete, setLoadingDelete] = useState(false);
  const handleDeleteAddress = async (id) => {
    Swal.fire({
      title: "آیا مطمئن هستید؟",
      text: "این آدرس حذف خواهد شد و امکان بازگردانی آن وجود ندارد!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "بله، حذف شود!",
      cancelButtonText: "لغو",
      dangerMode: true,
    }).then(async (result) => {
      if (result.isConfirmed) {
        setLoadingDelete(true);
        let res = await DeleteAddressService(id);

        if (res.status === 200) {
          setAddresses((prevAddresses) =>
            prevAddresses.filter((address) => address.id !== id)
          );

          if (id === selectdAdId) setSetselectdAddressId(0);

          Swal.fire({
            title: "آدرس با موفقیت حذف شد!",
            icon: "success",
            confirmButtonText: "فهمیدم",
          });
        } else
          Swal.fire({
            title: "حذف آدرس با خطا مواجه شد!",
            icon: "error",
            confirmButtonText: "فهمیدم",
          });

        setLoadingDelete(false);
      }
    });
  };
  return (
    <button
      type="button"
      className="badge badge-danger cart-item-remove text-white border-0"
      onClick={() => handleDeleteAddress(id)}
    >
      <i className={"fa fa-fw fa-times" + (loadingDelete ? " d-none" : "")} />
      <i
        className={
          "fa fa-fw fa-refresh fa-spin " + (!loadingDelete ? " d-none" : "")
        }
      />
      حذف
    </button>
  );
};

export const SendToPagePayment = ({ selectedAddressId }) => {
  const [processLoading, setProcessLoading] = useState(false);

  const handleShowMessageBefforNextProcess = () => {
    if (selectedAddressId)
      Swal.fire({
        title: "از انتخاب مطمئن هستید؟",
        text: "این آدرس به عنوان آدرس مقصد انتخاب خواهد شد و امکان تغییر ندارد!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "رفتن به درگاه",
        cancelButtonText: "لغو",
        dangerMode: true,
      }).then(async (result) => {
        if (result.isConfirmed) {
          setAddressIdCookie(selectedAddressId);
          let responseZarinPal = await RequestPaymentCartService(
            selectedAddressId
          );
          setAmountCookie(responseZarinPal.result.amount);
          window.location.href = responseZarinPal.result.link;
        }
      });
    else
      Swal.fire({
        title: "آدرس را انتخاب کنید!",
        icon: "warning",
        confirmButtonText: "باشه",
      });
  };

  return (
    <button
      //   onClick={handleShowMessageBefforNextProcess}
      onClick={handleShowMessageBefforNextProcess}
      type="button"
      className="btn btn-lg btn-primary btn-block btn-arrow-left rounded mt-25 col-3"
    >
      {processLoading ? (
        <i
          className={
            "fa fa-fw fa-refresh fa-spin " + (!processLoading ? " d-none" : "")
          }
        />
      ) : (
        "رفتن به درگاه پرداخت"
      )}
    </button>
  );
};
